import { Building2 } from 'lucide-react';

export const PartnerLogo = ({ name }) => {
  return (
    <div className="partner-logo-box">
      <Building2 
        size={32} 
        style={{ 
          color: 'hsl(var(--muted-foreground))',
          marginBottom: '0.5rem'
        }} 
      />
      <div style={{ 
        fontSize: '0.875rem', 
        fontWeight: '500',
        color: 'hsl(var(--foreground))'
      }}>
        {name}
      </div>
    </div>
  );
};
